import { NotificationProvider } from './context/NotificationContext'
import Notification from './components/ui/Notification'
import ScrollProgress from './components/ui/ScrollProgress'
import PWAUpdatePrompt from './components/ui/PWAUpdatePrompt'
import Navbar from './components/layout/Navbar'
import BottomNav from './components/layout/BottomNav'
import Footer from './components/layout/Footer'
import Hero from './components/sections/Hero'
import About from './components/sections/About'
import Services from './components/sections/Services'
import CaseStudies from './components/sections/CaseStudies'
import Impact from './components/sections/Impact'
import News from './components/sections/News'
import Contact from './components/sections/Contact'

function App() {
  return (
    <NotificationProvider>
      <div className="min-h-screen bg-canvas text-ink antialiased pb-[calc(4.75rem+env(safe-area-inset-bottom))] md:pb-0">
        <ScrollProgress />
        <Navbar />
        <main>
          <Hero />
          <About />
          <Services />
          <CaseStudies />
          <Impact />
          <News />
          <Contact />
        </main>
        <Footer />
        <Notification />
        <BottomNav />
        <PWAUpdatePrompt />
      </div>
    </NotificationProvider>
  )
}

export default App
